module.exports = __webpack_public_path__ + "media/channel_pages/neon-prairie-nights-50074b3a.png";